"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const components_1 = require("@/common/components");
const functions_1 = require("@/common/functions");
const Avatar_1 = __importDefault(require("@mui/material/Avatar"));
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1() {
    const roomCreateStep = (0, react_redux_1.useSelector)((state) => state.roomCreateStep);
    const isPreview = roomCreateStep === 'preview';
    const category = (0, react_redux_1.useSelector)((state) => state.roomData.category);
    const tags = (0, react_redux_1.useSelector)((state) => state.roomData.tag);
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(CategoryTagWrapper, { children: [(0, jsx_runtime_1.jsxs)("h1", { children: [(0, jsx_runtime_1.jsx)(svgs_1.CategoryIconOutlinedSvg, {}), t('관련 카테고리')] }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "chips_div" }, { children: !!category && ((0, jsx_runtime_1.jsx)(components_1.FondChip, { sx: { borderRadius: '4px' }, avatar: (0, jsx_runtime_1.jsx)(Avatar_1.default, Object.assign({ src: (0, functions_1.getCdnUrl)(category.img_url) }, { children: (0, jsx_runtime_1.jsx)("div", { className: "surface-table-row", css: { width: '100%', height: '100%' } }) })), label: category.name, onClick: () => !isPreview && (window.location.href = `/room/search?fond=${category.id}`) })) })), (0, jsx_runtime_1.jsxs)("h1", { children: [(0, jsx_runtime_1.jsx)(svgs_1.HashtagIconSvg, {}), t('관련 태그')] }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "chips_div", style: { marginBottom: 0 } }, { children: tags.map((tag, idx) => ((0, jsx_runtime_1.jsx)(components_1.FondChip, { sx: { borderRadius: '4px' }, label: tag, onClick: () => !isPreview && (window.location.href = `/room/search?keyword=${tag}`) }, `related_tag_${tag.substring(0, 5)}_${idx}`))) }))] }));
}
exports.default = default_1;
const CategoryTagWrapper = styled_1.default.div `
  padding: 20px 20px 8px;
  margin-bottom: 10px;
  background-color: white;
  h1 {
    display: flex;
    align-items: center;
    margin-bottom: 14px;
    font-size: 15px;
    font-weight: 600;
    svg {
      margin: 0 4px 0 -4px;
    }
  }
  .chips_div {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 4px;
    width: 100%;
    margin-bottom: 24px;
  }
`;
